module.exports = __webpack_public_path__ + "img/logo.5e8056bf.png";